import React, { Component } from "react";
import {
  DatePicker,
  Select,
  Radio,
  Space,
  Checkbox,
  message,
  Spin,
} from "antd";
import Bridge from "../../utils/Bridge";
import dayjs from "dayjs";
import moment from "moment";
import { logEvent } from "../../utils/analytics";

const { Option } = Select;

export default class MedicalHistory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      smoking_history: "",
      allergies: [
        {
          id: 1,
          name: "",
        },
      ],
      prescriptions: [
        {
          id: 1,
          name: "",
          dose: "",
          frequency: "",
          frequency_type: "",
          date_started: "",
          reason: "",
          units: "",
          unit_type: "",
          route: "",
          route_type: "",
        },
      ],
      surgeries: [
        {
          id: 1,
          type: "",
          location: "",
          date: "",
        },
      ],
      diagnosed_hair_loss: "",
      anything_apply_to_you: [],
      loading: false,
      have_you_quit_smoking_in_the_past_year: "",
      do_you_have_allergies: "",
      have_you_had_any_surgeries: "",
      // history
      bipolar_disorder: "",
      brain_aneurysm: "",
      cancer: "",
      depression: "",
      diabetes: "",
      epilepsy: "",
      muscle_disease: "",
      schizophrenia: "",
    };
  }
  componentDidMount() {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    this.get_demographic_details();
  }
  get_demographic_details = () => {
    let params = "?eals_id=" + localStorage.getItem("ap_eals_id");
    Bridge.demographics
      .get(params)
      .then((response) => {
        this.setState({ loading: false });
        if (response.status == "1") {
          if (response.data.length > 0) {
            for (let item of response.data) {
              if (item.field == "Smoking History") {
                this.setState({
                  smoking_history: item.value ? item.value : [],
                });
              }
              if (item.field == "Have you quit smoking in the past year?") {
                this.setState({
                  have_you_quit_smoking_in_the_past_year: item.value
                    ? item.value
                    : "",
                });
              }
              if (item.field == "Do you have any allergies?") {
                this.setState({
                  do_you_have_allergies: item.value ? item.value : "",
                });
              }
              if (item.field == "Allergies") {
                this.setState({
                  allergies: item.value
                    ? JSON.parse(item.value)
                    : [
                        {
                          id: 1,
                          name: "",
                        },
                      ],
                });
              }
              if (item.field == "Prescriptions") {
                let prescriptions = item.value
                  ? JSON.parse(item.value)
                  : [
                      {
                        id: 1,
                        name: "",
                        dose: "",
                        frequency: "",
                        frequency_type: "",
                        date_started: "",
                        reason: "",
                        units: "",
                        unit_type: "",
                        route: "",
                        route_type: "",
                      },
                    ];
                let p_arr = [];
                for (let pitem of prescriptions) {
                  if (pitem.date_started) {
                    pitem.date_started = dayjs(pitem.date_started);
                  }
                  p_arr.push(pitem);
                }
                this.setState({
                  prescriptions: item.value ? p_arr : [],
                });
              }
              if (item.field == "Have you had any surgeries?") {
                this.setState({
                  have_you_had_any_surgeries: item.value ? item.value : "",
                });
              }
              if (item.field == "Surgeries") {
                let surgeries = item.value
                  ? JSON.parse(item.value)
                  : [
                      {
                        id: 1,
                        type: "",
                        location: "",
                        date: "",
                      },
                    ];
                let s_arr = [];
                for (let sitem of surgeries) {
                  if (sitem.date) {
                    sitem.date = dayjs(sitem.date);
                  }
                  s_arr.push(sitem);
                }
                this.setState({
                  surgeries: item.value ? s_arr : [],
                });
              }
              // if (item.field == "Have you been diagnosed with hearing loss?") {
              //   this.setState({
              //     diagnosed_hair_loss: item.value ? item.value : "",
              //   });
              // }
              if (item.field == "Anything apply to you?") {
                this.setState({
                  anything_apply_to_you: item.value
                    ? JSON.parse(item.value)
                    : [],
                });
              }
              if (item.field == "Bipolar Disorder") {
                this.setState({
                  bipolar_disorder: item.value ? item.value : "",
                });
              }
              if (item.field == "Brain Aneurysm") {
                this.setState({
                  brain_aneurysm: item.value ? item.value : "",
                });
              }
              if (item.field == "Cancer") {
                this.setState({
                  cancer: item.value ? item.value : "",
                });
              }
              if (item.field == "Depression") {
                this.setState({
                  depression: item.value ? item.value : "",
                });
              }
              if (item.field == "Diabetes") {
                this.setState({
                  diabetes: item.value ? item.value : "",
                });
              }
              if (item.field == "Epilepsy") {
                this.setState({
                  epilepsy: item.value ? item.value : "",
                });
              }
              if (item.field == "Muscle Disease") {
                this.setState({
                  muscle_disease: item.value ? item.value : "",
                });
              }
              if (item.field == "Schizophrenia") {
                this.setState({
                  schizophrenia: item.value ? item.value : "",
                });
              }
            }
          }
        }
      })
      .catch((error) => {
        message.warning("Please try again!!", error);
        this.setState({ loading: false });
      });
  };
  save = () => {
    if (!this.state.smoking_history) {
      message.warning("Please select smoking history");
      return;
    }
    if (!this.state.do_you_have_allergies) {
      message.warning("Please select Do you have any allergies?");
      return;
    }
    if (this.state.do_you_have_allergies == "Yes") {
      if (this.state.allergies.length === 0) {
        message.warning("Please add allergy");
        return;
      }
      if (this.state.allergies.length > 0) {
        let list = this.state.allergies;
        for (let item of list) {
          if (!item.name) {
            message.warning("Please enter allergy name");
            return;
          }
        }
      }
    }
    if (this.state.prescriptions.length === 0) {
      message.warning("Please add prescription");
      return;
    }
    if (this.state.prescriptions.length > 0) {
      let list = this.state.prescriptions;
      for (let item of list) {
        if (!item.name) {
          message.warning("Please enter Prescription name");
          return;
        }
        // if (!item.dose) {
        //   message.warning("Please enter Prescription Dose name.");
        //   return;
        // }
        // if (!item.frequency) {
        //   message.warning("Please enter Frequency.");
        //   return;
        // }
        if (!item.date_started) {
          message.warning("Please select Prescription Date started.");
          return;
        }
      }
    }
    if (!this.state.have_you_had_any_surgeries) {
      message.warning("Please select Have you had any surgeries?");
      return;
    }
    if (this.state.have_you_had_any_surgeries == "Yes") {
      if (this.state.surgeries.length === 0) {
        message.warning("Please add surgery name");
        return;
      }
      if (this.state.surgeries.length > 0) {
        let list = this.state.surgeries;
        for (let item of list) {
          if (!item.type) {
            message.warning("Please enter Surgery Type");
            return;
          }
          if (!item.location) {
            message.warning("Please enter Surgery Location.");
            return;
          }
          if (!item.date) {
            message.warning("Please select Surgery Date.");
            return;
          }
        }
      }
    }
    // if (!this.state.diagnosed_hair_loss) {
    //   message.warning(
    //     "Please select 'Have you been diagnosed with hearing loss?' field"
    //   );
    //   return;
    // }
    let questions = [
      {
        parent_field: "Smoking History",
        field: "Smoking History",
        value: this.state.smoking_history,
      },
      {
        parent_field: "Have you quit smoking in the past year?",
        field: "Have you quit smoking in the past year?",
        value: this.state.have_you_quit_smoking_in_the_past_year,
      },
      {
        parent_field: "Do you have any allergies?",
        field: "Do you have any allergies?",
        value: this.state.do_you_have_allergies,
      },
      {
        parent_field: "Allergies",
        field: "Allergies",
        value: JSON.stringify(this.state.allergies),
      },
      {
        parent_field: "Prescriptions",
        field: "Prescriptions",
        value: JSON.stringify(this.state.prescriptions),
      },
      {
        parent_field: "Have you had any surgeries?",
        field: "Have you had any surgeries?",
        value: this.state.have_you_had_any_surgeries,
      },
      {
        parent_field: "Surgeries",
        field: "Surgeries",
        value: JSON.stringify(this.state.surgeries),
      },
      // {
      //   parent_field: "Have you been diagnosed with hearing loss?",
      //   field: "Have you been diagnosed with hearing loss?",
      //   value: this.state.diagnosed_hair_loss,
      // },
      // {
      //   parent_field: "Anything apply to you?",
      //   field: "Anything apply to you?",
      //   value: JSON.stringify(this.state.anything_apply_to_you),
      // },
      {
        parent_field: "Bipolar Disorder",
        field: "Bipolar Disorder",
        value: this.state.bipolar_disorder ? this.state.bipolar_disorder : "No",
      },
      {
        parent_field: "Brain Aneurysm",
        field: "Brain Aneurysm",
        value: this.state.brain_aneurysm ? this.state.brain_aneurysm : "No",
      },
      {
        parent_field: "Cancer",
        field: "Cancer",
        value: this.state.cancer ? this.state.cancer : "No",
      },
      {
        parent_field: "Depression",
        field: "Depression",
        value: this.state.depression ? this.state.depression : "No",
      },
      {
        parent_field: "Diabetes",
        field: "Diabetes",
        value: this.state.diabetes ? this.state.diabetes : "No",
      },
      {
        parent_field: "Epilepsy",
        field: "Epilepsy",
        value: this.state.epilepsy ? this.state.epilepsy : "No",
      },
      {
        parent_field: "Muscle Disease",
        field: "Muscle Disease",
        value: this.state.muscle_disease ? this.state.muscle_disease : "No",
      },
      {
        parent_field: "Schizophrenia",
        field: "Schizophrenia",
        value: this.state.schizophrenia ? this.state.schizophrenia : "No",
      },
    ];
    let params = {
      eals_id: localStorage.getItem("ap_eals_id"),
      data: JSON.stringify(questions),
      step: "5",
      action_type: this.props.is_update == true ? "update" : "insert",
    };
    this.setState({ loading: true });
    Bridge.demographics
      .save(params)
      .then((response) => {
        this.setState({ loading: false });
        if (response.data.status == "1") {
          logEvent("demographics_saved", { section: "medical_history" });
          message.success(response.data.message);
          this.setState(
            {
              loading: false,
            },
            () => {
              if (this.props.is_update == true) {
                setTimeout(() => {
                  window.location.assign("/about-me");
                }, 3000);
              } else {
                this.props.set_active_step(6);
              }
            }
          );
        } else {
          message.error(response.data.message);
          this.setState({ loading: false });
        }
      })
      .catch((error) => {
        message.warning("Please try again!!", error);
        this.setState({ loading: false });
      });
  };
  onChangeApplyFor = (e) => {
    let value = e.target.value;
    let tempArr = this.state.anything_apply_to_you;
    if (tempArr.includes(value)) {
      let newArray = [];
      for (let item of tempArr) {
        if (item != value) {
          newArray.push(item);
        }
      }
      this.setState({ anything_apply_to_you: newArray });
    } else {
      tempArr.push(value);
      this.setState({ anything_apply_to_you: tempArr });
    }
  };
  onChangeAllergy = (e) => {
  };
  getRandomInt = (min, max) => {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
  };
  add_new_allergy = () => {
    let arr = this.state.allergies;
    const randomInteger = this.getRandomInt(1, 2000);
    let obj = {
      id: randomInteger,
      name: "",
    };
    arr.push(obj);
    this.setState({ allergies: arr });
  };
  remove_allergy = (id) => {
    let arr = this.state.allergies;
    let tempArr = [];
    for (let single of arr) {
      if (single.id != id) {
        tempArr.push(single);
      }
    }
    this.setState({ allergies: tempArr });
  };
  update_allergy = (event, item) => {
    let arr = this.state.allergies;
    let tempArr = [];
    for (let single of arr) {
      if (single.id == item.id) {
        single.name = event.target.value;
      }
      tempArr.push(single);
    }
    this.setState({ allergies: tempArr });
  };
  add_new_prescription = () => {
    let arr = this.state.prescriptions;
    const randomInteger = this.getRandomInt(1, 2000);
    let obj = {
      id: randomInteger,
      name: "",
      dose: "",
      frequency: "",
      date_started: "",
    };
    arr.push(obj);
    this.setState({ prescriptions: arr });
  };
  remove_prescription = (id) => {
    let arr = this.state.prescriptions;
    let tempArr = [];
    for (let single of arr) {
      if (single.id != id) {
        tempArr.push(single);
      }
    }
    this.setState({ prescriptions: tempArr });
  };
  update_prescription = (event, item, field) => {
    let arr = this.state.prescriptions;
    let tempArr = [];
    for (let single of arr) {
      if (single.id == item.id) {
        if (field == "name") {
          single.name = event.target.value;
        }
        if (field == "dose") {
          single.dose = event.target.value;
        }
        if (field == "units") {
          single.units = event.target.value;
        }
        if (field == "unit_type") {
          single.unit_type = event.target.value;
        }
        if (field == "route") {
          single.route = event.target.value;
        }
        if (field == "route_type") {
          single.route_type = event.target.value;
        }
        if (field == "frequency") {
          single.frequency = event.target.value;
        }
        if (field == "frequency_type") {
          single.frequency_type = event.target.value;
        }
        if (field == "date_started") {
          single.date_started = event;
        }
        if (field == "reason") {
          single.reason = event.target.value;
        }
      }
      tempArr.push(single);
    }
    this.setState({ prescriptions: tempArr });
  };
  add_new_surgery = () => {
    let arr = this.state.surgeries;
    const randomInteger = this.getRandomInt(1, 2000);
    let obj = {
      id: randomInteger,
      type: "",
      location: "",
      date: "",
    };
    arr.push(obj);
    this.setState({ surgeries: arr });
  };
  update_surgery = (event, item, field) => {
    let arr = this.state.surgeries;
    let tempArr = [];
    for (let single of arr) {
      if (single.id == item.id) {
        if (field == "type") {
          single.type = event.target.value;
        }
        if (field == "location") {
          single.location = event.target.value;
        }
        if (field == "date") {
          single.date = event;
        }
      }
      tempArr.push(single);
    }
    this.setState({ surgeries: tempArr });
  };
  remove_surgery = (id) => {
    let arr = this.state.surgeries;
    let tempArr = [];
    for (let single of arr) {
      if (single.id != id) {
        tempArr.push(single);
      }
    }
    this.setState({ surgeries: tempArr });
  };
  onChangeDiagnosedHairLoss = (event) => {
    this.setState({ diagnosed_hair_loss: event.target.value });
  };
  render() {
    const disabledDate = (current) => {
      // Disable all dates after today
      return current && current > moment();
    };
    return (
      <div>
        <div className="header">
          <h3>MEDICAL HISTORY</h3>
          <div className="white-block"></div>
        </div>
        <Spin spinning={this.state.loading}>
          <div className="form-fields">
            <div className="form-group">
              <label className="mb-2 input-heading">
                Smoking History <span className="text-danger">*</span>
              </label>
              <br />
              <Select
                onChange={(value) =>
                  this.setState({
                    smoking_history: value,
                    have_you_quit_smoking_in_the_past_year: "",
                  })
                }
                value={this.state.smoking_history}
                style={{
                  width: "100%",
                  height: 55,
                  maxWidth: 500,
                }}
              >
                <Option value="">Select Smoking History</Option>
                <Option value="I currently smoke">I currently smoke</Option>
                <Option value="I have never smoked">I have never smoked</Option>
                <Option value="I previously smoked">I previously smoked</Option>
              </Select>
              {this.state.smoking_history == "I previously smoked" && (
                <div className="form-group mt-3">
                  <label className="input-heading">
                    Have you quit smoking in the past year?
                  </label>
                  <br />
                  <Radio.Group
                    onChange={(event) =>
                      this.setState({
                        have_you_quit_smoking_in_the_past_year:
                          event.target.value,
                      })
                    }
                    value={this.state.have_you_quit_smoking_in_the_past_year}
                    direction="vertical"
                  >
                    <Space direction="horizontal">
                      <Radio value={"Yes"}>Yes</Radio>
                      <Radio value={"No"}>No</Radio>
                    </Space>
                  </Radio.Group>
                </div>
              )}
            </div>
            <div className="form-group">
              <div className="d-flex justify-content-between col-lg-12">
                <label className="mb-2 input-heading">
                  Do you have any allergies?&nbsp;
                  <span className="text-danger">*</span>
                </label>
              </div>
              <Radio.Group
                onChange={(event) =>
                  this.setState({
                    do_you_have_allergies: event.target.value,
                    allergies: [
                      {
                        id: 1,
                        name: "",
                      },
                    ],
                  })
                }
                value={this.state.do_you_have_allergies}
                direction="vertical"
              >
                <Space direction="horizontal">
                  <Radio value={"Yes"}>Yes</Radio>
                  <Radio value={"No"}>No</Radio>
                </Space>
              </Radio.Group>
              <br />
              {this.state.do_you_have_allergies == "Yes" && (
                <div className="col-lg-9 mt-2">
                  <div className="d-flex justify-content-between col-lg-12 mb-3">
                    <label className="mb-2 input-heading"></label>
                    &nbsp;&nbsp;&nbsp;
                    <button
                      className="add_row_button"
                      onClick={() => this.add_new_allergy()}
                    >
                      {" "}
                      <box-icon name="plus-circle" color="#fff"></box-icon>{" "}
                      &nbsp;&nbsp;Add{" "}
                    </button>
                  </div>
                  <table className="medical-history-table">
                    <tr>
                      <th>
                        Allergies <span className="text-danger">*</span>
                      </th>
                      <th>Action</th>
                    </tr>
                    {this.state.allergies.map((item, index) => {
                      return (
                        <tr key={index}>
                          <td>
                            <input
                              type="text"
                              value={item.name}
                              style={{ height: 35 }}
                              onChange={(e) => this.update_allergy(e, item)}
                              maxLength={100}
                            />
                          </td>
                          <td>
                            <center>
                              <span
                                style={{ cursor: "pointer" }}
                                onClick={() => this.remove_allergy(item.id)}
                              >
                                <box-icon
                                  size={"20px"}
                                  name="trash"
                                  color="red"
                                ></box-icon>
                              </span>
                            </center>
                          </td>
                        </tr>
                      );
                    })}
                  </table>
                </div>
              )}
            </div>
            <div className="form-group">
              <div className="d-flex justify-content-between col-lg-12">
                <label className="mb-2 input-heading">
                  What are your current prescriptions?:
                  <span className="text-danger">*</span>
                </label>
                &nbsp;&nbsp;&nbsp;
                <button
                  className="add_row_button"
                  onClick={() => this.add_new_prescription()}
                >
                  {" "}
                  <box-icon name="plus-circle" color="#fff"></box-icon>{" "}
                  &nbsp;&nbsp;Add{" "}
                </button>
              </div>
              <br />
              <div className="col-lg-12">
                <table className="medical-history-table">
                  <tr>
                    <th style={{ width: 170 }}>
                      Medication<span className="text-danger">*</span>
                    </th>
                    <th style={{ width: 100 }}>Dose</th>
                    <th style={{ width: 80 }}>Units</th>
                    <th style={{ width: 60 }}>Route</th>
                    <th style={{ width: 60 }}>Frequency</th>
                    <th>
                      Start Date <span className="text-danger">*</span>
                    </th>
                    <th style={{ width: 60 }}>Reason</th>
                    <th>Action</th>
                  </tr>
                  {this.state.prescriptions.map((item, index) => {
                    return (
                      <tr key={index}>
                        <td>
                          <input
                            type="text"
                            value={item.name}
                            style={{ height: 35 }}
                            onChange={(e) =>
                              this.update_prescription(e, item, "name")
                            }
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            value={item.dose}
                            style={{ height: 35 }}
                            onChange={(e) =>
                              this.update_prescription(e, item, "dose")
                            }
                          />
                        </td>
                        <td>
                          <div className="d-flex flex-column">
                            <input
                              type="text"
                              value={item.units}
                              style={{
                                width: 67,
                                height: 35,
                                marginRight: 6,
                                marginBottom: 4,
                              }}
                              onChange={(e) =>
                                this.update_prescription(e, item, "units")
                              }
                            />
                            <select
                              value={item.unit_type}
                              onChange={(e) =>
                                this.update_prescription(e, item, "unit_type")
                              }
                              className="form-control"
                              style={{ width: 67, fontSize: 14 }}
                            >
                              <option value="">Select</option>
                              <option value="mg">Mg</option>
                              <option value="gm">Gm</option>
                              <option value="ug/mcg">Ug/mcg</option>
                              <option value="ml">mL</option>
                              <option value="units">Units</option>
                              <option value="tabs/caps">Tabs/Caps</option>
                              <option value="drop">Drop</option>
                              <option value="sprays">Sprays</option>
                              <option value="other">Other</option>
                            </select>
                          </div>
                        </td>
                        <td>
                          <div className="d-flex flex-column">
                            <input
                              type="text"
                              value={item.route}
                              style={{
                                width: 67,
                                height: 35,
                                marginRight: 6,
                                marginBottom: 4,
                              }}
                              onChange={(e) =>
                                this.update_prescription(e, item, "route")
                              }
                            />
                            <select
                              value={item.route_type}
                              onChange={(e) =>
                                this.update_prescription(e, item, "route_type")
                              }
                              className="form-control"
                              style={{ width: 67, fontSize: 14 }}
                            >
                              <option value="">Select</option>
                              <option value="po">po</option>
                              <option value="sl">sl</option>
                              <option value="sc">sc</option>
                              <option value="im">im</option>
                              <option value="iv">iv</option>
                              <option value="pr">pr</option>
                              <option value="td">td</option>
                              <option value="other">other</option>
                            </select>
                          </div>
                        </td>
                        <td>
                          <div className="d-flex flex-column">
                            <input
                              type="number"
                              min="0"
                              value={item.frequency}
                              style={{
                                height: 35,
                                width: 67,
                                marginRight: 6,
                                marginBottom: 4,
                              }}
                              onChange={(e) =>
                                this.update_prescription(e, item, "frequency")
                              }
                            />
                            <select
                              value={item.frequency_type}
                              onChange={(e) =>
                                this.update_prescription(
                                  e,
                                  item,
                                  "frequency_type"
                                )
                              }
                              className="form-control"
                              style={{ width: 67, fontSize: 14 }}
                            >
                              <option value="">Select</option>
                              <option value="qd">qd</option>
                              <option value="bid">bid</option>
                              <option value="tid">tid</option>
                              <option value="qid">qid</option>
                              <option value="qod">qod</option>
                              <option value="prn">prn</option>
                              <option value="other">other</option>
                            </select>
                          </div>
                        </td>
                        <td>
                          <DatePicker
                            picker="month"
                            disabledDate={disabledDate}
                            value={item.date_started}
                            onChange={(date, dateString) =>
                              this.update_prescription(
                                date,
                                item,
                                "date_started"
                              )
                            }
                            style={{
                              width: "100%",
                              height: 35,
                              maxWidth: 500,
                            }}
                            format={"MM/YYYY"}
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            value={item.reason}
                            style={{ width: 80, height: 35 }}
                            onChange={(e) =>
                              this.update_prescription(e, item, "reason")
                            }
                          />
                        </td>
                        <td>
                          <center>
                            <span
                              style={{ cursor: "pointer" }}
                              onClick={() => this.remove_prescription(item.id)}
                            >
                              <box-icon
                                size={"20px"}
                                name="trash"
                                color="red"
                              ></box-icon>
                            </span>
                          </center>
                        </td>
                      </tr>
                    );
                  })}
                </table>
              </div>
            </div>
            <div className="form-group">
              <label className="mb-2 input-heading">
                Have you had any surgeries?:
                <span className="text-danger">*</span>
              </label>
              <br />
              <Radio.Group
                onChange={(event) =>
                  this.setState({
                    have_you_had_any_surgeries: event.target.value,
                    ...(event.target.value === "No"
                      ? {
                          surgeries: [
                            {
                              id: 1,
                              type: "",
                              location: "",
                              date: "",
                            },
                          ],
                        }
                      : {}),
                  })
                }
                value={this.state.have_you_had_any_surgeries}
                direction="vertical"
              >
                <Space direction="horizontal">
                  <Radio value={"Yes"}>Yes</Radio>
                  <Radio value={"No"}>No</Radio>
                </Space>
              </Radio.Group>
              <br />
              {this.state.have_you_had_any_surgeries == "Yes" && (
                <>
                  <div className="d-flex justify-content-between col-lg-9 mt-2">
                    <label className="mb-2 input-heading"></label>
                    &nbsp;&nbsp;&nbsp;
                    <button
                      className="add_row_button"
                      onClick={() => this.add_new_surgery()}
                    >
                      {" "}
                      <box-icon name="plus-circle" color="#fff"></box-icon>{" "}
                      &nbsp;&nbsp;Add{" "}
                    </button>
                  </div>
                  <br />
                  <div className="col-lg-9">
                    <table className="medical-history-table">
                      <tr>
                        <th>
                          Surgery Type <span className="text-danger">*</span>
                        </th>
                        <th>
                          Surgery Location <span className="text-danger">*</span>
                        </th>
                        <th>
                          Surgery Date <span className="text-danger">*</span>
                        </th>
                        <th>Action</th>
                      </tr>
                      {this.state.surgeries.map((item, index) => {
                        return (
                          <tr key={index}>
                            <td>
                              <input
                                type="text"
                                value={item.type}
                                style={{ height: 35 }}
                                onChange={(e) =>
                                  this.update_surgery(e, item, "type")
                                }
                              />
                            </td>
                            <td>
                              <input
                                type="text"
                                value={item.location}
                                style={{ height: 35 }}
                                onChange={(e) =>
                                  this.update_surgery(e, item, "location")
                                }
                              />
                            </td>
                            <td>
                              <DatePicker
                                picker="month"
                                disabledDate={disabledDate}
                                value={item.date}
                                onChange={(date, dateString) =>
                                  this.update_surgery(date, item, "date")
                                }
                                style={{
                                  width: "100%",
                                  height: 35,
                                  maxWidth: 500,
                                }}
                                format={"MM/YYYY"}
                              />
                            </td>
                            <td>
                              <center>
                                <span
                                  style={{ cursor: "pointer" }}
                                  onClick={() => this.remove_surgery(item.id)}
                                >
                                  <box-icon
                                    size={"20px"}
                                    name="trash"
                                    color="red"
                                  ></box-icon>
                                </span>
                              </center>
                            </td>
                          </tr>
                        );
                      })}
                    </table>
                  </div>
                </>
              )}
            </div>
            {/* <div className="form-group">
              <label className="input-heading">
                Have you been diagnosed with hearing loss?{" "}
                <span className="text-danger">*</span>
              </label>
              <br />
              <Radio.Group
                onChange={this.onChangeDiagnosedHairLoss}
                value={this.state.diagnosed_hair_loss}
                direction="vertical"
              >
                <Space direction="horizontal">
                  <Radio value={"Yes"}>Yes</Radio>
                  <Radio value={"No"}>No</Radio>
                </Space>
              </Radio.Group>
            </div>
            <div className="form-group">
              <label className="input-heading">
                Do any of the following apply to you?{" "}
                <i style={{ fontWeight: "400" }}>
                  (please select any and all that apply)
                </i>
              </label>
              <ul>
                <li>
                  <Checkbox
                    checked={
                      this.state.anything_apply_to_you.includes(
                        "Hearing impaired / wear a hearing aid"
                      )
                        ? true
                        : false
                    }
                    value={"Hearing impaired / wear a hearing aid"}
                    onChange={this.onChangeApplyFor}
                  >
                    Hearing impaired / wear a hearing aid
                  </Checkbox>
                </li>
                <li>
                  <Checkbox
                    value={"Vision impaired / wear glasses"}
                    onChange={this.onChangeApplyFor}
                    checked={
                      this.state.anything_apply_to_you.includes(
                        "Vision impaired / wear glasses"
                      )
                        ? true
                        : false
                    }
                  >
                    Vision impaired / wear glasses
                  </Checkbox>
                </li>
                <li>
                  <Checkbox
                    value={"Currently wearing a dental appliance or dentures"}
                    onChange={this.onChangeApplyFor}
                    checked={
                      this.state.anything_apply_to_you.includes(
                        "Currently wearing a dental appliance or dentures"
                      )
                        ? true
                        : false
                    }
                  >
                    Currently wearing a dental appliance or dentures
                  </Checkbox>
                </li>
              </ul>
            </div> */}
            <div className="col-lg-12">
              <label className="mb-2 input-heading">
                Do you have a history of any of the following?:
              </label>
              <div className="form-group">
                <label className="input-heading" style={{ fontWeight: "400" }}>
                  Bipolar Disorder
                </label>
                <br />
                <Radio.Group
                  onChange={(e) =>
                    this.setState({ bipolar_disorder: e.target.value })
                  }
                  value={this.state.bipolar_disorder}
                >
                  <Space direction="horizontal">
                    <Radio value={"Yes"}>Yes</Radio>
                    <Radio value={"No"}>No</Radio>
                  </Space>
                </Radio.Group>
              </div>
              <div className="form-group">
                <label className="input-heading" style={{ fontWeight: "400" }}>
                  {" "}
                  Brain Aneurysm
                </label>
                <br />
                <Radio.Group
                  onChange={(e) =>
                    this.setState({ brain_aneurysm: e.target.value })
                  }
                  value={this.state.brain_aneurysm}
                >
                  <Space direction="horizontal">
                    <Radio value={"Yes"}>Yes</Radio>
                    <Radio value={"No"}>No</Radio>
                  </Space>
                </Radio.Group>
              </div>
              <div className="form-group">
                <label className="input-heading" style={{ fontWeight: "400" }}>
                  Cancer
                </label>
                <br />
                <Radio.Group
                  onChange={(e) => this.setState({ cancer: e.target.value })}
                  value={this.state.cancer}
                >
                  <Space direction="horizontal">
                    <Radio value={"Yes"}>Yes</Radio>
                    <Radio value={"No"}>No</Radio>
                  </Space>
                </Radio.Group>
              </div>
              <div className="form-group">
                <label className="input-heading" style={{ fontWeight: "400" }}>
                  Depression
                </label>
                <br />
                <Radio.Group
                  onChange={(e) =>
                    this.setState({ depression: e.target.value })
                  }
                  value={this.state.depression}
                >
                  <Space direction="horizontal">
                    <Radio value={"Yes"}>Yes</Radio>
                    <Radio value={"No"}>No</Radio>
                  </Space>
                </Radio.Group>
              </div>
              <div className="form-group">
                <label className="input-heading" style={{ fontWeight: "400" }}>
                  Diabetes
                </label>
                <br />
                <Radio.Group
                  onChange={(e) => this.setState({ diabetes: e.target.value })}
                  value={this.state.diabetes}
                >
                  <Space direction="horizontal">
                    <Radio value={"Yes"}>Yes</Radio>
                    <Radio value={"No"}>No</Radio>
                  </Space>
                </Radio.Group>
              </div>
              <div className="form-group">
                <label className="input-heading" style={{ fontWeight: "400" }}>
                  Epilepsy
                </label>
                <br />
                <Radio.Group
                  onChange={(e) => this.setState({ epilepsy: e.target.value })}
                  value={this.state.epilepsy}
                >
                  <Space direction="horizontal">
                    <Radio value={"Yes"}>Yes</Radio>
                    <Radio value={"No"}>No</Radio>
                  </Space>
                </Radio.Group>
              </div>
              <div className="form-group">
                <label className="input-heading" style={{ fontWeight: "400" }}>
                  Muscle Disease
                </label>
                <br />
                <Radio.Group
                  onChange={(e) =>
                    this.setState({ muscle_disease: e.target.value })
                  }
                  value={this.state.muscle_disease}
                >
                  <Space direction="horizontal">
                    <Radio value={"Yes"}>Yes</Radio>
                    <Radio value={"No"}>No</Radio>
                  </Space>
                </Radio.Group>
              </div>
              <div className="form-group">
                <label className="input-heading" style={{ fontWeight: "400" }}>
                  Schizophrenia
                </label>
                <br />
                <Radio.Group
                  onChange={(e) =>
                    this.setState({ schizophrenia: e.target.value })
                  }
                  value={this.state.schizophrenia}
                >
                  <Space direction="horizontal">
                    <Radio value={"Yes"}>Yes</Radio>
                    <Radio value={"No"}>No</Radio>
                  </Space>
                </Radio.Group>
              </div>
            </div>
            {this.props.is_update == true ? (
              <div className="d-flex mt-5">
                <button
                  className="submit-button ml-2"
                  style={{
                    marginLeft: 0,
                    padding: "9px 15px 10px 20px",
                  }}
                  onClick={() => this.save()}
                >
                  Save{" "}
                  <box-icon
                    name="chevron-right"
                    color="#fff"
                    style={{ position: "relative", top: 1 }}
                  ></box-icon>
                </button>
              </div>
            ) : (
              <div className="d-flex mt-5">
                <button
                  style={{
                    padding: "9px 28px 10px 21px",
                  }}
                  className="submit-button"
                  onClick={() => this.props.set_active_step(4)}
                >
                  <box-icon
                    name="chevron-left"
                    color="#fff"
                    style={{ position: "relative", top: 1 }}
                  ></box-icon>
                  Previous
                </button>
                <button
                  className="submit-button ml-2"
                  style={{
                    marginLeft: 17,
                    padding: "9px 15px 10px 20px",
                  }}
                  onClick={() => this.save()}
                >
                  Save & Next{" "}
                  <box-icon
                    name="chevron-right"
                    color="#fff"
                    style={{ position: "relative", top: 1 }}
                  ></box-icon>
                </button>
              </div>
            )}
          </div>
        </Spin>
      </div>
    );
  }
}
